import { getImageApiBase } from '@/renderer/utils/session';
import { overlayLibConfig } from '@/renderer/config/uiOverlayConfig';
export function writeRuntimeIframe(frame, html, onReady) {
    try {
        if (!frame)
            return;
        const doc = frame.contentDocument || frame.contentWindow?.document;
        if (!doc)
            return;
        const b64 = (str) => {
            try {
                return btoa(unescape(encodeURIComponent(str)));
            }
            catch {
                return btoa(str);
            }
        };
        const srcB64 = b64(html || '');
        const baseHref = getImageApiBase();
        try {
            console.log('[UI] writeRuntimeIframe start', { baseHref, htmlLen: (html || '').length });
        }
        catch { }
        const frameSrcExtras = (globalThis?.__ENV__?.FRAME_SRC_EXTRA || '').toString().trim();
        const cspExtras = overlayLibConfig?.csp || {};
        const join = (a, b) => [a?.trim(), b?.trim()].filter(Boolean).join(' ');
        const scriptSrcExtra = cspExtras.scriptSrc || '';
        const connectSrcExtra = cspExtras.connectSrc || '';
        const imgSrcExtra = cspExtras.imgSrc || '';
        const styleSrcExtra = cspExtras.styleSrc || '';
        const mediaSrcExtra = cspExtras.mediaSrc || '';
        const fontSrcExtra = cspExtras.fontSrc || '';
        const outerScripts = (overlayLibConfig?.outerScriptUrls || []).map((u) => `<script src="${u}"></script>`).join('');
        const innerScripts = (overlayLibConfig?.innerScriptUrls || []);
        const wrapperDoc = `<!DOCTYPE html>
<html>
<head>
  <meta charset=\"utf-8\" />
  <meta http-equiv=\"Content-Security-Policy\" content=\"default-src 'self' http: https: data: blob:; script-src 'self' 'unsafe-inline' 'unsafe-eval' http: https: blob: data: ${scriptSrcExtra}; style-src 'self' 'unsafe-inline' http: https: data: ${styleSrcExtra}; img-src 'self' http: https: data: blob: ${imgSrcExtra}; font-src 'self' http: https: data: ${fontSrcExtra}; media-src 'self' http: https: data: blob: ${mediaSrcExtra}; connect-src 'self' http: https: ws: wss: data: blob: ${connectSrcExtra}; worker-src 'self' blob:; frame-src 'self' http: https: data: blob: ${join(frameSrcExtras, cspExtras.frameSrc)}; object-src 'none'; base-uri *; form-action 'self' http: https:\" />
  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" />
  <style>
    html,body{height:100%;margin:0;overflow:hidden;background:transparent}
    #root{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;overflow:hidden}
    #inner{border:0;display:block;transform-origin:top left;background:transparent;width:100%;height:100%;}
  </style>
  <title>Runtime UI</title>
  ${outerScripts}
  </head>
  <body>
    <div id=\"root\"><iframe id=\"inner\" sandbox=\"allow-scripts allow-same-origin\"></iframe></div>
  </body>
  </html>`;
        doc.open();
        doc.write(wrapperDoc);
        doc.close();
        const onLoad = () => {
            try {
                onReady?.();
            }
            catch { }
        };
        // Build child document (full page if server provided, else fragment wrapper)
        const buildChildDoc = (fragStr) => {
            // Unwrap nested iframe srcdoc provided by server (if any)
            try {
                const raw = String(fragStr || '').trim();
                const m = raw.match(/^<iframe\b[^>]*\bsrcdoc=\"([\s\S]*?)\"[^>]*><\/iframe>$/i);
                if (m && m[1]) {
                    const ta = (doc || document).createElement('textarea');
                    ta.innerHTML = m[1];
                    fragStr = ta.value || raw;
                    try {
                        console.log('[UI] buildChildDoc: unwrapped nested iframe srcdoc');
                    }
                    catch { }
                }
            }
            catch { }
            const isFullDoc = /^\s*<\s*(!DOCTYPE|html)\b/i.test(fragStr);
            const extras = join(frameSrcExtras, cspExtras.frameSrc).replace(/"/g, '&quot;');
            const innerScriptTags = innerScripts.map((u) => `<script src=\"${u}\"></script>`).join('');
            const bootScript = ('<script>(function(){try{\n' +
                '  // Provide triggerSlash as a built-in for UI code inside the sandboxed frame.\n' +
                '  if (typeof window.triggerSlash !== "function") {\n' +
                '    window.triggerSlash = function(input){\n' +
                '      try {\n' +
                '        var s = (input==null?"":String(input));\n' +
                '        try { console.log("[inner] triggerSlash called", s); } catch(_) {}\n' +
                '        if (window.parent && typeof window.parent.postMessage === "function") {\n' +
                '          window.parent.postMessage(s, "*");\n' +
                '          try { console.log("[inner] triggerSlash posted to parent"); } catch(_) {}\n' +
                '        } else {\n' +
                '          try { console.warn("[inner] no parent.postMessage available"); } catch(_) {}\n' +
                '        }\n' +
                '      } catch(e) { try { console.warn("[inner] triggerSlash error", e); } catch(_) {} }\n' +
                '    };\n' +
                '  } else { try { console.log("[inner] triggerSlash already defined"); } catch(_) {} }\n' +
                '}catch(e){ try { console.warn("[inner] boot error", e); } catch(_) {} })();</script>');
            if (isFullDoc) {
                let out = fragStr;
                if (/<\/head>/i.test(out))
                    out = out.replace(/<\/head>/i, innerScriptTags + bootScript + '</head>');
                else if (/<body[^>]*>/i.test(out))
                    out = out.replace(/<body[^>]*>/i, (m) => m + innerScriptTags + bootScript);
                else
                    out += innerScriptTags + bootScript;
                try {
                    console.log('[UI] buildChildDoc: injected scripts into full document');
                }
                catch { }
                return out;
            }
            return '<!DOCTYPE html><html><head><meta charset="utf-8"/>' +
                '<meta http-equiv="Content-Security-Policy" content="default-src \'self\' http: https: data: blob:; script-src \'self\' \'unsafe-inline\' \'unsafe-eval\' http: https: blob: data: ' + (scriptSrcExtra ? scriptSrcExtra + ' ' : '') + '; style-src \'self\' \'unsafe-inline\' http: https: data: ' + (styleSrcExtra ? styleSrcExtra + ' ' : '') + '; img-src \'self\' http: https: data: blob: ' + (imgSrcExtra ? imgSrcExtra + ' ' : '') + '; font-src \'self\' http: https: data: ' + (fontSrcExtra ? fontSrcExtra + ' ' : '') + '; media-src \'self\' http: https: data: blob: ' + (mediaSrcExtra ? mediaSrcExtra + ' ' : '') + '; connect-src \'self\' http: https: ws: wss: data: blob: ' + (connectSrcExtra ? connectSrcExtra + ' ' : '') + '; worker-src \'self\' blob:; frame-src \'self\' http: https: data: blob: ' + (extras ? extras + ' ' : '') + '; object-src \'none\'; base-uri *; form-action \'self\' http: https:" />' +
                '<base href="' + (baseHref.replace(/\\/g, '').replace(/\/$/, '') + '/') + '" />' +
                '<meta name="viewport" content="width=device-width, initial-scale=1"/>' +
                '<style>html,body{height:100%;margin:0;overflow:hidden;background:#fff;color:#000}*,*::before,*::after{box-sizing:border-box}#ui-root{position:relative;width:100%;height:100%;overflow:auto}img,canvas,video{max-width:100%;height:auto;display:block}</style>' +
                innerScriptTags + bootScript + '</head><body><div id="ui-root">' + fragStr + '</div></body></html>';
        };
        // Try to mount inner.srcdoc immediately without relying on inline script
        const mountInner = () => {
            try {
                const idoc = frame.contentDocument || frame.contentWindow?.document;
                const inner = idoc?.getElementById('inner');
                if (!inner)
                    return false;
                inner.addEventListener('load', () => {
                    try {
                        console.log('[UI] inner iframe load event');
                    }
                    catch { }
                    ;
                    // Expose selected globals from outer -> inner
                    try {
                        const outWin = frame.contentWindow;
                        const inWin = inner.contentWindow;
                        const names = overlayLibConfig?.outerExposeGlobals || [];
                        names.forEach((n) => { try {
                            if (n && outWin && inWin && outWin[n] && !inWin[n])
                                inWin[n] = outWin[n];
                        }
                        catch { } });
                        // Ensure triggerSlash exists in inner window as a built-in
                        try {
                            if (inWin && typeof inWin.triggerSlash !== 'function') {
                                inWin.triggerSlash = new inWin.Function('input', [
                                    'try {',
                                    '  var s = (input==null?"":String(input));',
                                    '  try { console.log("[inner] triggerSlash called (injected)", s); } catch(_) {}',
                                    '  if (window.parent && typeof window.parent.postMessage === "function") {',
                                    '    window.parent.postMessage(s, "*");',
                                    '    try { console.log("[inner] triggerSlash posted to parent (injected)"); } catch(_) {}',
                                    '  } else { try { console.warn("[inner] no parent.postMessage available (injected)"); } catch(_) {} }',
                                    '} catch(e) { try { console.warn("[inner] triggerSlash error (injected)", e); } catch(_) {} }'
                                ].join('\n'));
                                try {
                                    console.log('[UI] injected triggerSlash into inner window');
                                }
                                catch { }
                            }
                            else {
                                try {
                                    console.log('[UI] triggerSlash already present in inner window');
                                }
                                catch { }
                            }
                        }
                        catch (e) {
                            try {
                                console.warn('[UI] failed to inject triggerSlash into inner', e);
                            }
                            catch { }
                        }
                    }
                    catch { }
                    onLoad();
                }, { once: true });
                inner.srcdoc = buildChildDoc(html || '');
                return true;
            }
            catch (e) {
                try {
                    console.warn('[UI] mountInner failed', e);
                }
                catch { }
                return false;
            }
        };
        if (!mountInner()) {
            // Retry shortly in case document not fully available yet
            setTimeout(() => { mountInner(); }, 0);
        }
    }
    catch (e) {
        try {
            console.warn('writeRuntimeIframe failed:', e);
        }
        catch { }
    }
}
